<template>
  <div class="menu-icon" :class="{ 'open': open }">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
  export default {
    name: 'MenuIcon',

    props: {
      open: {
        type: Boolean
      }
    }
  }
</script>

<style lang="postcss">
.menu-icon {
  width: 20px;
  height: 15px;
  position: relative;
  margin:0 auto;
  transform: rotate(0deg);
  transition: .5s ease-in-out;
  cursor: pointer;

  span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: currentColor;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: .25s ease-in-out;

    &:nth-child(1) {
      top: 0px;
    }

    &:nth-child(2),
    &:nth-child(3) {
      top: 6px;
    }

    &:nth-child(4) {
      top: 12px;
    }
  }

  &.open span:nth-child(1) {
    top: 6px;
    width: 0%;
    left: 50%;
  }

  &.open span:nth-child(2) {
    transform: rotate(45deg);
  }

  &.open span:nth-child(3) {
    transform: rotate(-45deg);
  }

  &.open span:nth-child(4) {
    top: 6px;
    width: 0%;
    left: 50%;
  }
}
</style>